function Contact() {
  return (
    <>
      <p>
        Разработчик: Галата Виталий Викторович, тел.{' '}
        <a href="tel:0937647459">0937647459</a>
      </p>
      <p>
        Телеграмм:{' '}
        <a href="https://t.me/vitaliygalata" target="_blank" rel="noreferrer">
          vitaliygalata
        </a>
      </p>
      <p>
        email: <a href="mailto:nertis44@gmail.com">nertis44@gmail.com</a>
      </p>
    </>
  );
}

export default Contact;
